import {mixins} from "../app/mixin";

mixins.push({
    el: '.sustainabilityConsultancyPage',
    data() {
        return {
            selectedStep: 1,
            heights: [],
        }
    },
    methods: {
        selectStep(index) {
            if (index !== this.selectedStep) {
                this.selectedStep = index;
            }
        },
    },
});